const doc = [({"ja":({"constantBookingStatus":({"arranged":"予約済み", "cancelled":"キャンセル済み", "requested":"リクエスト中", "modified":"変更済み"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;